import { render, staticRenderFns } from "./TheMailTrackingForm.vue?vue&type=template&id=4f8c43d4&scoped=true&lang=pug&"
import script from "./TheMailTrackingForm.vue?vue&type=script&lang=js&"
export * from "./TheMailTrackingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c43d4",
  null
  
)

export default component.exports